<template>
    <v-container fluid>
        <h2>Assinaturas</h2>
    </v-container>
</template>
<script>
export default {
    name:"acompanhamento",
}
</script>